import { useBackendData } from './useBackendData';
import { userService } from './User/userService';

export const usePublicUserData = (userId: number) => useBackendData(userService.fetchPublicUser, userId);
